import { SortEvent } from 'primeng/api'

export type TableGetData<T> = (
  exportAll?: boolean,
  offset?: number,
  limit?: number,
  sort?: SortEvent,
) => Promise<T[]>

/** One stable getData function per row object, so [getData] doesn't change on every CD pass */
export function perItemGetData<I extends object, T>(
  build: (item: I) => TableGetData<T>,
): (item: I) => TableGetData<T> {
  const cache = new WeakMap<I, TableGetData<T>>()
  return (item) => {
    let fn = cache.get(item)
    if (!fn) {
      fn = build(item)
      cache.set(item, fn)
    }
    return fn
  }
}
